import React, { useEffect } from "react";
import "animate.css";
import Section from "./Section";
import Section02 from "./Section02";
import { Element, scroller } from "react-scroll";
import { useLocation } from "react-router-dom";
import WhyTeamsPrefer from "../Pricing/WhyTeamsPrefer";

const evenData = [
  {
    Id: "1",
    Title1: "Purchase Partner Management",
    // Title2: "Source-to-Contract and Procure-to-Pay",
    text: "Serves as a strategic framework to oversee and optimize relationships with external vendors, contractors, and suppliers. It focuses on aligning partner performance with corporate objectives to ensure high-quality delivery, cost-efficiency, and long-term scalability. By implementing standardized evaluation and communication protocols, organizations can effectively mitigate supply chain risks and foster collaborative innovation. Ultimately, this approach transforms traditional vendor interactions into value-driven partnerships that support sustainable business growth.",
    image: "./assets/images/purchaseMng.png",
    // image: "./assets/flowimage/PARTNER.PNG",
    path: "/features",
  },
  {
    Id: "2",
    Title1: "Asset Management",
    // Title2: "Sourcing, Contract Management...",
    text: "Provides a centralized framework for supervising and maintaining an organization's high-value physical and digital resources throughout their entire lifecycle. It integrates strategic planning with real-time tracking to optimize performance, minimize operational downtime, and ensure rigorous regulatory compliance. By leveraging predictive maintenance and data-driven risk assessment, businesses can significantly extend asset longevity while reducing total cost of ownership. This proactive approach ensures that capital investments remain aligned with evolving enterprise goals and financial objectives.",
    image: "./assets/images/AssetMng.png",
    path: "/features",
  },
  {
    Id: "3",
    Title1: "AP Automation",
    // Title2: "Procurement and Virtual Cards",
    text: "(Accounts Payable Automation) refers to the strategic deployment of digital technologies to streamline the entire invoice-to-pay lifecycle. By utilizing AI-driven data extraction and automated three-way matching—aligning invoices with purchase orders and receiving reports—organizations can virtually eliminate manual data entry and human error. This transformation accelerates financial close cycles, strengthens internal controls against fraud, and enhances working capital management through timely payment scheduling. Ultimately, it shifts the finance department from a reactive cost center to a proactive, data-driven strategic partner.",
    image: "./assets/images/apAuto.png",
    path: "/features",
  },

  {
    Id: "3",
    Title1: "Logistics Management",
    // Title2: "Supply Chain Modeler, Demand Modeler...",
    text: "Logistics Management is the strategic process of planning, implementing, and controlling the efficient movement and storage of goods, services, and information from the point of origin to the point of consumption. It integrates complex functions such as transportation, warehousing, materials handling, and order fulfillment into a cohesive operation to meet customer requirements with precision. By leveraging real-time tracking and predictive analytics, organizations can optimize route efficiency, reduce lead times, and significantly lower operational overhead. This comprehensive oversight ensures a resilient supply chain that can rapidly adapt to global market shifts while maintaining high service-level standards.",
    image: "./assets/images/LogisticsMng.png",
    path: "/features",
  },
  {
    Id: "4",
    Title1: "Profit Ledger",
    // Title2: "Analytics",
    text: "Profit Ledger serves as a high-level financial intelligence framework that bridges the gap between operational activities and bottom-line fiscal performance. It provides executive-level visibility by consolidating data from sales, procurement, and production to track real-time profitability across various business units or product lines. By utilizing advanced cost-allocation models and margin analysis, the system enables leadership to identify high-performing sectors and mitigate hidden operational leakages. This strategic oversight ensures that every enterprise decision is grounded in accurate financial data, ultimately driving sustainable growth and maximized shareholder value.",
    image: "./assets/images/ProfitMng.png",
    path: "/features",
  },
];
const oddData = [
  {
    Id: "1",
    Title1: "Customer Sales Management",
    // Title2: "Source-to-Contract and Procure-to-Pay",
    text: "Focuses on the strategic orchestration of the entire sales lifecycle, from lead acquisition to final conversion and post-purchase engagement. It leverages data-driven insights to align sales strategies with customer needs, ensuring a seamless and personalized journey that maximizes lifetime value. By optimizing sales pipelines and fostering strong client relationships, organizations can drive sustainable revenue growth and improve market positioning. This systematic approach ensures that sales teams are empowered to deliver consistent results while maintaining high levels of customer satisfaction and loyalty.",
    image: "./assets/images/customerMng.png",
    path: "/features",
  },

  {
    Id: "2",
    Title1: "Production Management",
    // Title2: "Procurement and Virtual Cards",
    text: "Orchestrates the complex integration of personnel, machinery, and materials to achieve peak manufacturing excellence and operational efficiency. It utilizes real-time data monitoring and Lean methodologies to streamline production workflows, minimize waste, and ensure stringent quality control standards are met. By synchronizing shop-floor activities with enterprise-level resource planning, the system enables agile responses to shifting market demands and supply chain fluctuations. Ultimately, this comprehensive oversight maximizes throughput while maintaining the highest safety and sustainability benchmarks across the production facility.",
    image: "./assets/images/factoryMng.png",
    path: "/features",
  },

  {
    Id: "3",
    Title1: "Product Hub and Life Cycle",
    // Title2: "PO Collaboration and Forecast Collaboration",
    text: "The integration of a Product Hub with Product Lifecycle Management (PLM) creates a unified digital thread that governs a product from its initial engineering concept to its final market delivery. While the PLM manages the strategic phases of R&D, compliance, and manufacturing revisions, the Product Hub acts as the centralized repository for the resulting commercial data and digital assets. This synergy ensures that every stakeholder—from design engineers to marketing teams—operates from a Single Source of Truth accelerating time-to-market and ensuring that complex product specifications remain consistent across all global distribution channels.",
    image: "./assets/images/ProductMng.png",
    path: "/features",
  },
  {
    Id: "4",
    Title1: "Supply Inventory Management",
    // Title2: "Payment, Expense Management.",
    text: "Supply Inventory Management is a critical operational discipline focused on the systematic oversight of stock levels to ensure a seamless balance between supply and demand. It utilizes advanced forecasting models and real-time tracking to minimize carrying costs while preventing stockouts that could disrupt production or fulfillment cycles. By integrating automated replenishment triggers and rigorous audit protocols, organizations gain granular visibility into their material flow and working capital. This strategic approach enhances supply chain resilience, allowing businesses to maintain lean operations while remaining agile enough to respond to sudden market fluctuations.",
    image: "./assets/images/supplyMNg.png",
    path: "/features",
  },
];

const Product = () => {
  const location = useLocation();

  useEffect(() => {
    const section = location.hash.replace("#", "");
    if (section) {
      scroller.scrollTo(section, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    }
  }, [location]);

  return (
    <>
      <div className="container products">
        <Element name="vendoremanagement">
          <div className="common-wdt common-wdt-top">
            {/* <h1 className="product-title">Product</h1> */}
            <div className="text-center mb-5">
              <h2 className="product-title">
                Transform Your Business in<span> Digital Era</span>
              </h2>
              <p className="pricing-subtitle">
                Choose a module that’s right for you
              </p>
            </div>
            <Section evenData={evenData[0]} />
          </div>
        </Element>

        <Element name="sourcetopay">
          <div className="common-wdt">
            <Section02 oddData={oddData[0]} />
          </div>
        </Element>

        <Element name="sourcetocontract">
          <div className="common-wdt">
            <Section evenData={evenData[1]} />
          </div>
        </Element>

        <Element name="procuretopay">
          <div className="common-wdt">
            <Section02 oddData={oddData[1]} />
          </div>
        </Element>

        <Element name="procuretoorder">
          <div className="common-wdt">
            <Section evenData={evenData[2]} />
          </div>
        </Element>

        <Element name="supplychainsynergy">
          <div className="common-wdt">
            <Section02 oddData={oddData[2]} />
          </div>
        </Element>

        <Element name="supplychainstrategy">
          <div className="common-wdt">
            <Section evenData={evenData[3]} />
          </div>
        </Element>

        <Element name="paymentautomation">
          <div className="common-wdt">
            <Section02 oddData={oddData[3]} />
          </div>
        </Element>

        <Element name="Analytics">
          <div className="common-wdt">
            <Section evenData={evenData[4]} />
          </div>
        </Element>
      </div>
      <WhyTeamsPrefer
        title="See how VENSAP meets your unique business needs"
        highlight="Book a customized demo today"
        buttonLabel="Book a demo"
      />
    </>
  );
};

export default Product;
